import { render, staticRenderFns } from "./CampaignsFilters.vue?vue&type=template&id=ebcce028&scoped=true"
import script from "./CampaignsFilters.vue?vue&type=script&lang=ts"
export * from "./CampaignsFilters.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsFilters.vue?vue&type=style&index=0&id=ebcce028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcce028",
  null
  
)

export default component.exports